
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ISituacion } from './../models/IDocumentosSituacion.model';

@Injectable({
    providedIn: 'root'
})
export class documentoService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public act_secuencia(documento: any) {
        return this.httpClient.put(environment.serviceUrl + "documento/act-secuencia", documento, { observe: 'response' },)
    }

    public obtener(documento: number) {
        return this.httpClient.get(environment.serviceUrl + "documento/" + documento, { observe: 'response' },)
    }

    obtenerDocumento(codTipoDocumento: any, serie: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.execGetQueryJson(`${codTipoDocumento}/${serie}`)
    }

    buscarDocumento(codTipoDocumento: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.execGetQueryJson(`${codTipoDocumento}`)
    }

    insertDocumento(data: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarDocumento(data: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarDocumento(codTipoDocumento: any, serie: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.executeDeleteJson(`${codTipoDocumento}/${serie}`)
    }

    eliminarClase(codigo: any, series: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi("documento/clase/");
        return this.apiService.executeDeleteJson(`${codigo}/${series}/${clase}`)
    }

    obtener_clase(codigo: any, series: any, clase: any): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "documento/clase/" + codigo + "/" + series + "/" + clase, { observe: 'response' })
    }

    obtener_clases(): Observable<any> {
        this.apiService.setUrlPathApi("documento/clase/buscar");
        return this.apiService.execGetJson();
    }
    
    /************ Documento Situacion**************/
    insertDocumentoSituacion(SituacionDocumento: ISituacion) {
        this.apiService.setUrlPathApi("situacion/");
        return this.apiService.executePostJson(SituacionDocumento).pipe();
    }

    actualizarDocumentoSituacion(SituacionDocumento: ISituacion) {
        this.apiService.setUrlPathApi("situacion/");
        return this.apiService.executePutJson(SituacionDocumento).pipe();
    }

    eliminarDocumentoSituacion(tipdoc: any, situac: any) {
        this.apiService.setUrlPathApi("situacion/");
        return this.apiService.executeDeleteJson(`${tipdoc}/${situac}`)
    }

    obtenerDocumentoSituacion(tipdoc: any, situac: any) {
        this.apiService.setUrlPathApi("situacion/buscar");
        return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&situaciones=${situac}`)
    }
    // ObtenerDetalleDocumento 
    obtenerDetalleDocumento(numint: any,all: any): Observable<any> {
        this.apiService.setUrlPathApi(`documento-generico/${numint}`);
        return this.apiService.execGetQueryJson(`?all=${all}`);
    }
    obtenerDetalleDocumentov2(serie: any,numdoc: any): Observable<any> {
        this.apiService.setUrlPathApi(`documento-generico/v2/obtener`);
        return this.apiService.execGetQueryJson(`?serie=${serie}&numdoc=${numdoc}`);
    }
    //obtener tipo de documento por Serie - nro
    obtenerTipdocSerieNumero(tipdoc:any,serie:any,numero:any,all:any){
       this.apiService.setUrlPathApi(`documento-generico/${tipdoc}/${serie}/${numero}`);
       return this.apiService.execGetQueryJson(`?all=${all}`);

    }
    //obtener Acta de entrega
    obtenerpdfFormatoActaEntrega(numint:any,numite:any){
        this.apiService.setUrlPathApi("documentoCab/");
        return this.apiService.execGetQueryJsonPDF(`${numint}/item/${numite}/acta-entrega.pdf`).pipe();
    }

    actualiza_placa(etiqueta: any, placa: any): Observable<any> {
        this.apiService.setUrlPathApi(`guia-interna`+`/actualiza-placa?etiqueta=${etiqueta}&placa=${placa}`);
        return this.apiService.executePutJson(null).pipe();
    }

    actualiza_dam(numint: any, dam: any): Observable<any> {
        this.apiService.setUrlPathApi(`guia-interna`+`/actualiza-dam?numint=${numint}&dam=${dam}`);
        return this.apiService.executePutJson(null).pipe();
    }
}


/*
@Path("/situacion")
public interface SituacionRestService {

    @POST
    @Path("/")
    @Produces(MediaType.APPLICATION_JSON)
    public Response insertar(Situacion sender, @HeaderParam("Authorization") String auth);

    @PUT
    @Path("/")
    @Produces(MediaType.APPLICATION_JSON)
    public Response actualizar(Situacion sender, @HeaderParam("Authorization") String auth);

    @DELETE
    @Path("/{tipdoc}/{situac}")
    @Produces(MediaType.APPLICATION_JSON)
    public Response eliminar(@PathParam("tipdoc") Integer tipdoc, @PathParam("situac") String situac,
	    @HeaderParam("Authorization") String auth);

    @GET
    @Path("/buscar")
    @Produces(MediaType.APPLICATION_JSON)
    public Response buscar(@QueryParam("tipdoc") Integer tipdoc, @QueryParam("situaciones") String situaciones,
	    @HeaderParam("Authorization") String auth);

*/